import { render, staticRenderFns } from "./Regolamenti.vue?vue&type=template&id=0f582026&"
import script from "./Regolamenti.vue?vue&type=script&lang=js&"
export * from "./Regolamenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports